import axios from "../../../../api/axios";
import { AchievementsResponse, AchievementPostsResponse } from "../types/achievements.types";

const ACHIEVEMENT_POSTS_PAGE_LIMIT = 10;

export const getEntityAchievements = async (entityId: string): Promise<AchievementsResponse> => {
  try {
    const response = await axios.get<AchievementsResponse>(`football-entities/${entityId}/achievements`);
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch entity achievements: ${(err as Error).message}`);
  }
};

export const getAchievementPosts = async (
  entityId: string,
  achievementId: string,
  limit: number = ACHIEVEMENT_POSTS_PAGE_LIMIT,
  offset: number = 0
): Promise<AchievementPostsResponse> => {
  try {
    const response = await axios.get<AchievementPostsResponse>(
      `football-entities/${entityId}/achievements/${achievementId}/posts?limit=${limit}&offset=${offset}`
    );
    return response.data;
  } catch (err) {
    throw new Error(`Failed to fetch achievement posts: ${(err as Error).message}`);
  }
};

export type UpdateAchievementPayload = Array<{
  id: number;
  count: number;
}>;

export const updateEntityAchievements = async (
  entityId: string,
  data: UpdateAchievementPayload
): Promise<AchievementsResponse> => {
  try {
    const response = await axios.put<AchievementsResponse>(`football-entities/${entityId}/achievements`, {
      achievements: data,
    });
    return response.data;
  } catch (err) {
    throw new Error(`Failed to update entity achievements: ${(err as Error).message}`);
  }
};
